export default class Answer {
    AnswerText: string;
    IsCorrect: boolean;
}
